import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTrash, faPlus, faEdit } from '@fortawesome/free-solid-svg-icons';
import Header from '../components/header';
import BaseURL from '../assets/contants/BaseURL';
import axios from 'axios';

const ScheduleDetails = () => {
    const [schedules, setSchedules] = useState([]);
    const [emsGroups, setEmsGroups] = useState([]);
    const [machines, setMachines] = useState([]);
    const [checkedItems, setCheckedItems] = useState({});
    const [energyMeters, setEnergyMeters] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [pagination, setPagination] = useState({
        current_page: 1,
        total_pages: 1,
        previous: null,
        next: null
    });
    const [isModalOpen, setModalOpen] = useState(false);
    const addMachineModalRef = useRef();
    const [newSchedule, setNewSchedule] = useState({
        name: '',
        schedule_time: '',
        active: 'false',
        report_type: '',
        report: '',
        user_list: [],
        meter_list: [],
        enpi_list: [],
        ems_group_list: []
    });
    const [searchMeter, setSearchMeter] = useState('');
    const [filteredMeter, setFilteredMeter] = useState([]);
    const [addedMeters, setAddedMeters] = useState([]);
    const [addsearchTerm, setAddSearchTerm] = useState('');
    const [userList, setUserList] = useState([]);
    const [usersData, setUsersData] = useState({});
    const reportTypeOptions = ['daily', 'monthly'];
    const reportOptions = {
        daily: ['EnPI', 'meters', 'EMS Group'],
        monthly: ['EnPI', 'meters', 'EMS Group']
    };
    const [searchEmsGroup, setSearchEmsGroup] = useState('');
    const [filteredEmsGroups, setFilteredEmsGroups] = useState([]);
    const [addedEmsGroups, setAddedEmsGroups] = useState([]);

    const [searchMachine, setSearchMachine] = useState('');
    const [filteredMachines, setFilteredMachines] = useState([]);
    const [addedMachines, setAddedMachines] = useState([]);

    const [editingSchedule, setEditingSchedule] = useState({
        id: null,
        name: '',
        schedule_time: '',
        active: false,
        report_type: '',
        report: '',
        user_list: [],
        meter_list: [],
        enpi_list: [],
        ems_group_list: []
    });
    const [isEditModalOpen, setEditModalOpen] = useState(false);
    const editMachineModalRef = useRef();
    const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

    const fetchSchedules = async () => {
        try {
            const response = await fetch(`${BaseURL}alerts/schedule-report-details/`);
            const data = await response.json();
            setSchedules(data);
        } catch (error) {
            console.error('Error fetching schedules:', error);
        }
    };

    const fetchEmsGroups = async () => {
        try {
            const response = await fetch(`${BaseURL}meters/emsgroups/`);
            const data = await response.json();
            setEmsGroups(data);
        } catch (error) {
            console.error('Error fetching EMS groups:', error);
        }
    };

    const fetchMachines = async () => {
        try {
            const response = await fetch(`${BaseURL}meters/machine/`);
            const data = await response.json();
            setMachines(data);
        } catch (error) {
            console.error('Error fetching machines:', error);
        }
    };

    const fetchEnergyMeters = async () => {
        try {
            const response = await fetch(`${BaseURL}meters/energymeters/`);
            const data = await response.json();
            setEnergyMeters(data);
            setFilteredMeter(response.data);
        } catch (error) {
            console.error('Error fetching energy meters:', error);
        }
    };

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const token = sessionStorage.getItem('token');
                const usersResponse = await axios.get(`${BaseURL}Userauth/userdetail/`, {
                    headers: {
                        Authorization: `Token ${token}`,
                    },
                });

                const usersMap = usersResponse.data.reduce((map, obj) => {
                    if (obj.usermod && obj.usermod.username) {
                        map[obj.user_id] = obj.usermod.username;
                    } else {
                        console.error('Missing usermod or username:', obj);
                    }
                    return map;
                }, {});

                setUsersData(usersMap);
            } catch (error) {
                console.error('Error fetching products:', error);
            }
        };

        fetchUsers();
    }, []);

    useEffect(() => {
        fetchSchedules();
        fetchEmsGroups();
        fetchMachines();
        fetchEnergyMeters();
    }, []);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleSelectRow = (id) => {
        setSelectedRows(prev => {
            if (prev.includes(id)) {
            return prev.filter(rowId => rowId !== id);
            } else {
            return [...prev, id];
            }
        });
        setCheckedItems(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        const newCheckedItems = {};
        const newSelectedRows = [];
        
        schedules.forEach((schedule) => {
            newCheckedItems[schedule.id] = isChecked;
            if (isChecked) {
            newSelectedRows.push(schedule.id);
            }
        });
        
        setCheckedItems(newCheckedItems);
        setSelectedRows(newSelectedRows);
        setIsAllSelected(isChecked);
    };

    const handlePageChange = (page) => {
        setPagination(prev => ({
            ...prev,
            current_page: page
        }));
    };

    const getEmsGroupNames = (groupIds) => {
        return groupIds.map(id => {
            const group = emsGroups.find(g => g.group_id === id);
            return group ? group.group_name : `Group ${id}`;
        }).join(', ');
    };

    const getMachineNames = (machineIds) => {
        return machineIds.map(id => {
            const machine = machines.find(m => m.id === id);
            return machine ? machine.machine_name : `Machine ${id}`;
        }).join(', ');
    };

    const getMeterNames = (meterIds) => {
        return meterIds.map(id => {
            const meter = energyMeters.find(m => m.id === id);
            return meter ? meter.meter_name : `Meter ${id}`;
        }).join(', ');
    };

    const filteredSchedules = schedules.filter(schedule =>
        schedule.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        schedule.report.toLowerCase().includes(searchQuery.toLowerCase()) ||
        schedule.report_type.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const inputStyle = {
        padding: '8px',
        borderRadius: '10px',
        border: '1px solid #ced4da',
        width: '100%',
        fontSize: '14px',
        boxSizing: 'border-box',
    };

    const handleRemoveMeter = (meterId) => {
        setAddedMeters(prev => prev.filter(meter => meter.meter_id !== meterId));
    };

    const handleAddMeter = (meter) => {
        if (!addedMeters.some(m => m.meter_id === meter.meter_id)) {
            setAddedMeters(prevAddedMeters => [...prevAddedMeters, meter]);
        } else {
            console.log(`Meter ID ${meter.meter_id} is already added.`);
        }
    };

    const handlemeterSearch = () => {
        if (searchMeter.trim() === '') {
            setFilteredMeter(energyMeters);
        } else {
            const filtered = energyMeters.filter((meter) =>
                meter.meter_id.toLowerCase().includes(searchMeter.toLowerCase()) ||
                meter.meter_name.toLowerCase().includes(searchMeter.toLowerCase())
            );
            setFilteredMeter(filtered);
        }
    };

    const handlemeterSearchChange = (e) => {
        setSearchMeter(e.target.value);
    };

    useEffect(() => {
        handlemeterSearch();
    }, [searchMeter, energyMeters]);

    const handleAddUser = (userId) => {
        if (!userList.includes(userId)) {
            setUserList([...userList, userId]);
        }
    };

    const handleRemoveUser = (userId) => {
        setUserList(userList.filter(id => id !== userId));
    };

    const filteredUsers = Object.entries(usersData).filter(([userId, username]) =>
        username.toLowerCase().includes(addsearchTerm.toLowerCase())
    );

    const handleReportTypeChange = (e) => {
        const selectedType = e.target.value;
        setNewSchedule({
            ...newSchedule,
            report_type: selectedType,
            report: ''
        });
    };

    const handleReportChange = (e) => {
        setNewSchedule({
            ...newSchedule,
            report: e.target.value
        });
    };

    const handleAddEmsGroup = (group) => {
        if (!addedEmsGroups.some(g => g.group_name === group.group_name)) {
            setAddedEmsGroups([...addedEmsGroups, group]);
        }
    };

    const handleRemoveEmsGroup = (groupName) => {
        setAddedEmsGroups(addedEmsGroups.filter(group => group.group_name !== groupName));
    };

    const handleEmsGroupSearchChange = (e) => {
        setSearchEmsGroup(e.target.value);
    };

    const handleAddMachine = (machine) => {
        if (!addedMachines.some(m => m.id === machine.id)) {
            setAddedMachines([...addedMachines, machine]);
        }
    };

    const handleRemoveMachine = (machineId) => {
        setAddedMachines(addedMachines.filter(machine => machine.id !== machineId));
    };

    const handleMachineSearchChange = (e) => {
        setSearchMachine(e.target.value);
    };

    useEffect(() => {
        if (searchEmsGroup.trim() === '') {
            setFilteredEmsGroups(emsGroups);
        } else {
            const filtered = emsGroups.filter(group =>
                group.group_name.toLowerCase().includes(searchEmsGroup.toLowerCase()) ||
                group.group_id.toString().includes(searchEmsGroup)
            );
            setFilteredEmsGroups(filtered);
        }
    }, [searchEmsGroup, emsGroups]);

    useEffect(() => {
        if (searchMachine.trim() === '') {
            setFilteredMachines(machines);
        } else {
            const filtered = machines.filter(machine =>
                machine.machine_name.toLowerCase().includes(searchMachine.toLowerCase()) ||
                machine.id.toString().includes(searchMachine)
            );
            setFilteredMachines(filtered);
        }
    }, [searchMachine, machines]);

    const handleAddSchedule = async () => {
        try {
            const scheduleData = {
                name: newSchedule.name,
                schedule_time: newSchedule.schedule_time,
                active: newSchedule.active === 'true',
                report_type: newSchedule.report_type,
                report: newSchedule.report,
                user_list: userList,
                enpi_list: addedMachines.map(machine => machine.id),
                ems_group_list: addedEmsGroups.map(group => group.group_id),
                meter_list: addedMeters.map(meter => meter.id)
            };

            const response = await axios.post(
                `${BaseURL}alerts/schedule-report-details/`,
                scheduleData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Token ${sessionStorage.getItem('token')}`
                    }
                }
            );

            setSuccessMessage('Schedule added successfully');
            setTimeout(() => setSuccessMessage(''), 3000);
            setModalOpen(false);

            setNewSchedule({
                name: '',
                schedule_time: '',
                active: 'false',
                report_type: '',
                report: '',
                user_list: [],
                meter_list: [],
                enpi_list: [],
                ems_group_list: []
            });
            setUserList([]);
            setAddedMeters([]);
            setAddedEmsGroups([]);
            setAddedMachines([]);

            fetchSchedules();
        } catch (error) {
            console.error('Error adding schedule:', error);
            const errorMessage = error.response?.data?.message ||
                error.response?.data?.detail ||
                'Failed to add schedule';
            setSuccessMessage(errorMessage);
            setTimeout(() => setSuccessMessage(''), 3000);
        }
    };

    const handleEditClick = (schedule) => {
        setEditingSchedule({
            id: schedule.id,
            name: schedule.name,
            schedule_time: schedule.schedule_time,
            active: schedule.active,
            report_type: schedule.report_type,
            report: schedule.report,
            user_list: schedule.user_list
        });

        setAddedMeters(energyMeters.filter(meter => schedule.meter_list.includes(meter.id)));
        setAddedEmsGroups(emsGroups.filter(group => schedule.ems_group_list.includes(group.group_id)));
        setAddedMachines(machines.filter(machine => schedule.enpi_list.includes(machine.id)));
        setUserList(schedule.user_list);

        setEditModalOpen(true);
    };

    const handleUpdateSchedule = async () => {
        try {
            const scheduleData = {
                name: editingSchedule.name,
                schedule_time: editingSchedule.schedule_time,
                active: editingSchedule.active,
                report_type: editingSchedule.report_type,
                report: editingSchedule.report,
                user_list: userList,
                enpi_list: addedMachines.map(machine => machine.id),
                ems_group_list: addedEmsGroups.map(group => group.group_id),
                meter_list: addedMeters.map(meter => meter.id)
            };

            console.log("Sending update data:", scheduleData);

            const response = await axios.put(
                `${BaseURL}alerts/schedule-report-details/${editingSchedule.id}/`,
                scheduleData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Token ${sessionStorage.getItem('token')}`
                    }
                }
            );

            setSuccessMessage('Schedule updated successfully');
            setTimeout(() => setSuccessMessage(''), 3000);
            setEditModalOpen(false);
            fetchSchedules();
        } catch (error) {
            console.error('Error updating schedule:', error);
            const errorMessage = error.response?.data?.message ||
                error.response?.data?.detail ||
                JSON.stringify(error.response?.data) ||
                'Failed to update schedule';
            setSuccessMessage(errorMessage);
            setTimeout(() => setSuccessMessage(''), 3000);
        }
    };

    const handleDeleteSchedules = async () => {
        const idsToDelete = Object.keys(checkedItems).filter(id => checkedItems[id]);
        if (idsToDelete.length === 0) {
            setDeleteModalOpen(false);
            return;
        }

        try {
            const deletePromises = idsToDelete.map(id => 
            axios.delete(`${BaseURL}alerts/schedule-report-details/${id}/`, {
                headers: {
                Authorization: `Token ${sessionStorage.getItem('token')}`
                }
            })
            );
            
            await Promise.all(deletePromises);
            
            setSuccessMessage(`${idsToDelete.length} schedule(s) deleted successfully`);
            setTimeout(() => setSuccessMessage(''), 3000);

            setCheckedItems({});
            setSelectedRows([]);
            setIsAllSelected(false);

            fetchSchedules();
        } catch (error) {
            console.error('Error deleting schedules:', error);
            setSuccessMessage('Failed to delete schedules');
            setTimeout(() => setSuccessMessage(''), 3000);
        } finally {
            setDeleteModalOpen(false);
        }
    };


    return (
        <div style={{ textAlign: 'center', width: '100%' }}>
            <div style={{
                backgroundColor: '#007acc',
                color: 'white',
                alignContent: 'center',
                fontSize: '14px',
                height: '40px'
            }}>
                <Header title="SCHEDULE DETAILS" />
            </div>

            <div style={{
                border: '1px solid #ccc',
                padding: '10px',
                marginTop: '20px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                backgroundColor: 'white',
                margin: '20px auto',
                maxWidth: '1000px',
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '60%' }}>
                        <input
                            type="text"
                            placeholder="Search"
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{
                                padding: '10px',
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                flex: '1',
                                marginRight: '10px',
                            }}
                        />
                        <FontAwesomeIcon
                            icon={faSearch}
                            style={{ color: '#007acc', cursor: 'pointer', marginRight: '10px' }}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <button
                            style={{
                                padding: '10px 15px',
                                backgroundColor: '#4CAF50',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                marginRight: '10px',
                            }}
                            onClick={() => setModalOpen(true)}
                        >
                            <FontAwesomeIcon icon={faPlus} style={{ marginRight: '5px' }} />
                            Add
                        </button>
                        <button
                            style={{
                                padding: '10px 15px',
                                marginRight: '10px',
                                backgroundColor: '#f44336',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                            }}
                            onClick={() => {
                                const selected = Object.keys(checkedItems).filter(id => checkedItems[id]);
                                if (selected.length > 0) {
                                    setDeleteModalOpen(true);
                                } else {
                                    setSuccessMessage('Please select at least one schedule to delete');
                                    setTimeout(() => setSuccessMessage(''), 3000);
                                }
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} style={{ marginRight: '5px' }} />
                            Delete
                        </button>
                    </div>
                </div>
            </div>

            <div style={{ textAlign: 'center', margin: '20px 0' }}>
                {successMessage && (
                    <div style={{
                        padding: '10px',
                        borderRadius: '5px',
                        backgroundColor: '#4CAF50',
                        color: 'white',
                        margin: '10px auto',
                        width: 'fit-content',
                    }}>
                        {successMessage}
                    </div>
                )}
            </div>

            <div style={{
                marginTop: '20px',
                padding: '10px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                backgroundColor: 'white',
                maxWidth: '1000px',
                margin: '20px auto',
                marginBottom: '70px',
            }}>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse', minWidth: '800px' }}>
                        <thead style={{ backgroundColor: '#007acc', color: 'white' }}>
                            <tr>
                                <th style={{ padding: '10px' }}>
                                    <input
                                        type="checkbox"
                                        onChange={handleSelectAll}
                                        checked={isAllSelected}
                                        ref={el => {
                                            if (el) {
                                                el.indeterminate =
                                                    selectedRows.length > 0 &&
                                                    !isAllSelected;
                                            }
                                        }}
                                    />
                                </th>
                                <th style={{ padding: '10px' }}>Name</th>
                                <th style={{ padding: '10px' }}>Schedule Time</th>
                                <th style={{ padding: '10px' }}>Report Type</th>
                                <th style={{ padding: '10px' }}>Report</th>
                                <th style={{ padding: '10px' }}>EMS Groups</th>
                                <th style={{ padding: '10px' }}>Machines</th>
                                <th style={{ padding: '10px' }}>Meters</th>
                                <th style={{ padding: '10px' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredSchedules.map((schedule, index) => (
                                <tr key={schedule.id} style={{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : '#ffffff' }}>
                                    <td style={{ padding: '10px' }}>
                                        <input
                                            type="checkbox"
                                            checked={checkedItems[schedule.id] || false}
                                            onChange={() => handleSelectRow(schedule.id)}
                                        />
                                    </td>
                                    <td style={{ padding: '10px' }}>{schedule.name}</td>
                                    <td style={{ padding: '10px' }}>{schedule.schedule_time}</td>
                                    <td style={{ padding: '10px' }}>{schedule.report_type}</td>
                                    <td style={{ padding: '10px' }}>{schedule.report}</td>
                                    <td style={{ padding: '10px' }}>{getEmsGroupNames(schedule.ems_group_list)}</td>
                                    <td style={{ padding: '10px' }}>{getMachineNames(schedule.enpi_list)}</td>
                                    <td style={{ padding: '10px' }}>{getMeterNames(schedule.meter_list)}</td>
                                    <td style={{ padding: '10px', color: 'blue', cursor: 'pointer', textAlign: 'center' }} onClick={() => handleEditClick(schedule)} >
                                        <FontAwesomeIcon icon={faEdit} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <button
                        onClick={() => handlePageChange(pagination.current_page - 1)}
                        disabled={!pagination.previous}
                        style={{
                            margin: '0 5px',
                            padding: '5px 10px',
                            background: !pagination.previous ? '#cccccc' : '#007acc',
                            color: !pagination.previous ? '#666666' : '#ffffff',
                            border: 'none',
                            borderRadius: '25px',
                            cursor: !pagination.previous ? 'not-allowed' : 'pointer',
                            fontSize: '12px',
                        }}
                    >
                        Previous
                    </button>

                    {Array.from({ length: pagination.total_pages }, (_, i) => i + 1).map(page => (
                        <button
                            key={page}
                            onClick={() => handlePageChange(page)}
                            style={{
                                margin: '0 5px',
                                padding: '5px 10px',
                                background: pagination.current_page === page ? '#007acc' : '#f0f0f0',
                                color: pagination.current_page === page ? '#ffffff' : '#333333',
                                border: 'none',
                                borderRadius: '25px',
                                cursor: 'pointer',
                                fontSize: '12px',
                            }}
                        >
                            {page}
                        </button>
                    ))}

                    <button
                        onClick={() => handlePageChange(pagination.current_page + 1)}
                        disabled={!pagination.next}
                        style={{
                            margin: '0 5px',
                            padding: '5px 10px',
                            background: !pagination.next ? '#cccccc' : '#007acc',
                            color: !pagination.next ? '#666666' : '#ffffff',
                            border: 'none',
                            borderRadius: '25px',
                            cursor: !pagination.next ? 'not-allowed' : 'pointer',
                            fontSize: '12px',
                        }}
                    >
                        Next
                    </button>
                </div>
            </div>
            {isModalOpen && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div
                        ref={addMachineModalRef}
                        style={{
                            backgroundColor: 'white',
                            padding: '30px',
                            borderRadius: '8px',
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
                            width: '60%',
                            maxWidth: '600px',
                            height: '480px',
                            transition: 'all 0.3s ease',
                            overflowX: 'auto'
                        }}
                    >
                        <h4 style={{ marginBottom: '20px', textAlign: 'center' }}>Add New Schedule</h4>
                        <div style={{ display: 'flex', gap: '30px' }}>
                            <div style={{ flex: '1', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                <div style={{ display: 'flex', gap: '20px' }}>
                                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                                        <label>
                                            Schedule Name <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            value={newSchedule.name}
                                            onChange={(e) => setNewSchedule({ ...newSchedule, name: e.target.value })}
                                            placeholder="Enter Schedule Name"
                                            style={{
                                                padding: '10px',
                                                border: '1px solid #ccc',
                                                borderRadius: '8px',
                                                width: '95%',
                                            }}
                                        />
                                    </div>
                                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                                        <label>
                                            Schedule Time <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <input
                                            type="time"
                                            value={newSchedule.schedule_time || ''}
                                            onChange={(e) => setNewSchedule({ ...newSchedule, schedule_time: e.target.value })}
                                            step="60"
                                            style={inputStyle}
                                            pattern="[0-9]{2}:[0-9]{2}"
                                        />
                                    </div>
                                </div>

                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '20px',
                                }}>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center'
                                    }}>
                                        <label style={{ marginBottom: '5px' }}>
                                            Active State <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <input
                                                type="checkbox"
                                                id="custom-checkbox"
                                                style={{ display: 'none' }}
                                                checked={newSchedule.active === 'true'}
                                                onChange={(e) => setNewSchedule({
                                                    ...newSchedule,
                                                    active: e.target.checked ? 'true' : 'false'
                                                })}
                                            />
                                            <label
                                                htmlFor="custom-checkbox"
                                                style={{
                                                    width: '40px',
                                                    height: '20px',
                                                    backgroundColor: newSchedule.active === 'true' ? '#4caf50' : '#ccc',
                                                    borderRadius: '50px',
                                                    position: 'relative',
                                                    cursor: 'pointer',
                                                    transition: 'background-color 0.3s',
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        position: 'absolute',
                                                        top: '3px',
                                                        left: newSchedule.active === 'true' ? '20px' : '3px',
                                                        width: '14px',
                                                        height: '14px',
                                                        backgroundColor: 'white',
                                                        borderRadius: '50%',
                                                        transition: '0.3s',
                                                    }}
                                                />
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', gap: '20px' }}>
                                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                                        <label>
                                            Report Type <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <select
                                            value={newSchedule.report_type}
                                            onChange={handleReportTypeChange}
                                            style={{
                                                padding: '10px',
                                                border: '1px solid #ccc',
                                                borderRadius: '8px',
                                                width: '100%',
                                            }}
                                        >
                                            <option value="">Select Report Type</option>
                                            {reportTypeOptions.map((type) => (
                                                <option key={type} value={type}>
                                                    {type.charAt(0).toUpperCase() + type.slice(1)}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                                        <label>
                                            Report <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <select
                                            value={newSchedule.report}
                                            onChange={handleReportChange}
                                            disabled={!newSchedule.report_type}
                                            style={{
                                                padding: '10px',
                                                border: '1px solid #ccc',
                                                borderRadius: '8px',
                                                width: '100%',
                                            }}
                                        >
                                            <option value="">Select Report</option>
                                            {newSchedule.report_type &&
                                                reportOptions[newSchedule.report_type].map((report) => (
                                                    <option key={report} value={report}>
                                                        {report}
                                                    </option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                                {(newSchedule.report === 'meters') && (
                                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', marginBottom: '10px' }}>
                                        <div style={{ flex: '1' }}>
                                            <label htmlFor="meters" style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>Meters List</label>
                                            <div style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', height: '150px', overflowY: 'auto' }}>
                                                <input
                                                    type="text"
                                                    placeholder="Search meters..."
                                                    value={searchMeter}
                                                    onChange={handlemeterSearchChange}
                                                    style={{ padding: '5px', marginBottom: '10px', width: '90%', border: '1px solid #ccc', borderRadius: '4px' }}
                                                />
                                                {filteredMeter.map((meter, index) => (
                                                    <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px', backgroundColor: '#f9f9f9', padding: '5px', borderRadius: '4px' }}>
                                                        <div>
                                                            <span style={{ fontSize: '12px', display: 'block' }}>{meter.meter_name} - {meter.meter_id}</span>
                                                        </div>
                                                        <button
                                                            onClick={() => handleAddMeter(meter)}
                                                            disabled={addedMeters.some(m => m.meter_id === meter.meter_id)}
                                                            style={{
                                                                background: addedMeters.some(m => m.meter_id === meter.meter_id) ? 'gray' : 'green',
                                                                color: 'white',
                                                                border: 'none',
                                                                borderRadius: '5px',
                                                                padding: '5px',
                                                                cursor: addedMeters.some(m => m.meter_id === meter.meter_id) ? 'not-allowed' : 'pointer',
                                                                fontSize: '10px',
                                                            }}
                                                        >
                                                            {addedMeters.some(m => m.meter_id === meter.meter_id) ? 'Added' : 'Add'}
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div style={{ flex: '1' }}>
                                            <label style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>Added Meters</label>
                                            <div style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', height: '150px', overflowY: 'auto' }}>
                                                {addedMeters.map((meter, index) => (
                                                    <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px', backgroundColor: '#f9f9f9', padding: '5px', borderRadius: '4px' }}>
                                                        <div>
                                                            <span style={{ fontSize: '12px', display: 'block' }}>{meter.meter_name} - {meter.meter_id}</span>
                                                        </div>
                                                        <button
                                                            onClick={() => handleRemoveMeter(meter.meter_id)}
                                                            style={{
                                                                background: 'red',
                                                                color: 'white',
                                                                border: 'none',
                                                                borderRadius: '5px',
                                                                padding: '5px',
                                                                cursor: 'pointer',
                                                                fontSize: '10px',
                                                            }}
                                                        >
                                                            Remove
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', marginBottom: '10px' }}>
                            <div style={{ flex: '1' }}>
                                <label style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>
                                    User Select
                                </label>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        padding: '10px',
                                        borderRadius: '5px',
                                        border: '1px solid #ccc',
                                        backgroundColor: '#f9f9f9',
                                        height: '150px',
                                        overflowY: 'auto',
                                        position: 'relative',
                                    }}
                                >
                                    <input
                                        type="text"
                                        value={addsearchTerm}
                                        onChange={(e) => setAddSearchTerm(e.target.value)}
                                        placeholder="Search users..."
                                        style={{
                                            padding: '8px',
                                            borderRadius: '5px',
                                            border: '1px solid #ccc',
                                            marginBottom: '10px',
                                            width: '90%',
                                        }}
                                    />

                                    <div>
                                        {filteredUsers.map(([userId, username]) => {
                                            const isUserAdded = userList.includes(userId);
                                            return (
                                                <div
                                                    key={userId}
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        backgroundColor: '#e0e0e0',
                                                        alignItems: 'center',
                                                        padding: '5px',
                                                        borderRadius: '5px',
                                                        marginBottom: '8px',
                                                        fontSize: '12px',
                                                    }}
                                                >
                                                    <span style={{ color: isUserAdded ? 'gray' : 'black' }}>{username}</span>
                                                    <button
                                                        onClick={() => handleAddUser(userId)}
                                                        style={{
                                                            backgroundColor: isUserAdded ? 'gray' : '#4CAF50',
                                                            color: 'white',
                                                            border: 'none',
                                                            padding: '5px 10px',
                                                            borderRadius: '5px',
                                                            cursor: isUserAdded ? 'not-allowed' : 'pointer',
                                                            fontSize: '10px',
                                                            marginLeft: '10px',
                                                        }}
                                                        disabled={isUserAdded}
                                                    >
                                                        {isUserAdded ? 'Added' : 'Add'}
                                                    </button>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: '48%' }}>
                                <label style={{ marginBottom: '8px', display: 'block', fontWeight: 'bold' }}>
                                    Added Users
                                </label>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        padding: '10px',
                                        borderRadius: '5px',
                                        border: '1px solid #ccc',
                                        backgroundColor: '#f9f9f9',
                                        height: '150px',
                                        overflowY: 'auto',
                                    }}
                                >
                                    {userList.map(userId => (
                                        <div
                                            key={userId}
                                            style={{
                                                backgroundColor: '#e0e0e0',
                                                marginBottom: '5px',
                                                padding: '2px',
                                                borderRadius: '3px',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                fontSize: '12px'
                                            }}
                                        >
                                            <span>{usersData[userId]}</span>
                                            <button
                                                onClick={() => handleRemoveUser(userId)}
                                                style={{
                                                    backgroundColor: 'red',
                                                    color: 'white',
                                                    border: 'none',
                                                    padding: '5px',
                                                    borderRadius: '5px',
                                                    cursor: 'pointer',
                                                    fontSize: '10px'
                                                }}
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        {(newSchedule.report === 'EMS Group') && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', marginBottom: '10px' }}>
                                <div style={{ flex: '1' }}>
                                    <label style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>
                                        EMS Groups List
                                    </label>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            padding: '10px',
                                            borderRadius: '5px',
                                            border: '1px solid #ccc',
                                            backgroundColor: '#f9f9f9',
                                            height: '150px',
                                            overflowY: 'auto',
                                            position: 'relative',
                                        }}
                                    >
                                        <input
                                            type="text"
                                            placeholder="Search EMS groups..."
                                            value={searchEmsGroup}
                                            onChange={handleEmsGroupSearchChange}
                                            style={{
                                                padding: '8px',
                                                borderRadius: '5px',
                                                border: '1px solid #ccc',
                                                marginBottom: '10px',
                                                width: '90%',
                                            }}
                                        />

                                        <div>
                                            {filteredEmsGroups.map((group, index) => (
                                                <div key={index} style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    backgroundColor: '#e0e0e0',
                                                    alignItems: 'center',
                                                    padding: '5px',
                                                    borderRadius: '5px',
                                                    marginBottom: '8px',
                                                    fontSize: '12px',
                                                }}>
                                                    <div>
                                                        <span style={{ fontSize: '12px', display: 'block' }}>{group.group_name}</span>
                                                    </div>
                                                    <button
                                                        onClick={() => handleAddEmsGroup(group)}
                                                        disabled={addedEmsGroups.some(g => g.group_name === group.group_name)}
                                                        style={{
                                                            background: addedEmsGroups.some(g => g.group_name === group.group_name) ? 'gray' : 'green',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '5px',
                                                            padding: '5px',
                                                            cursor: addedEmsGroups.some(g => g.group_name === group.group_name) ? 'not-allowed' : 'pointer',
                                                            fontSize: '10px',
                                                        }}
                                                    >
                                                        {addedEmsGroups.some(g => g.group_name === group.group_name) ? 'Added' : 'Add'}
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: '48%' }}>
                                    <label style={{ marginBottom: '8px', display: 'block', fontWeight: 'bold' }}>
                                        Added EMS Groups
                                    </label>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            padding: '10px',
                                            borderRadius: '5px',
                                            border: '1px solid #ccc',
                                            backgroundColor: '#f9f9f9',
                                            height: '150px',
                                            overflowY: 'auto',
                                        }}
                                    >
                                        {addedEmsGroups.map((group, index) => (
                                            <div key={index} style={{
                                                backgroundColor: '#e0e0e0',
                                                marginBottom: '5px',
                                                padding: '2px',
                                                borderRadius: '3px',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                fontSize: '12px'
                                            }}>
                                                <div>
                                                    <span style={{ fontSize: '12px', display: 'block' }}>{group.group_name}</span>
                                                </div>
                                                <button
                                                    onClick={() => handleRemoveEmsGroup(group.group_name)}
                                                    style={{
                                                        background: 'red',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '5px',
                                                        padding: '5px',
                                                        cursor: 'pointer',
                                                        fontSize: '10px',
                                                    }}
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                        {(newSchedule.report === 'EnPI') && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', marginBottom: '10px' }}>
                                <div style={{ flex: '1' }}>
                                    <label style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>
                                        Machines List
                                    </label>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            padding: '10px',
                                            borderRadius: '5px',
                                            border: '1px solid #ccc',
                                            backgroundColor: '#f9f9f9',
                                            height: '150px',
                                            overflowY: 'auto',
                                            position: 'relative',
                                        }}
                                    >
                                        <input
                                            type="text"
                                            placeholder="Search machines..."
                                            value={searchMachine}
                                            onChange={handleMachineSearchChange}
                                            style={{
                                                padding: '8px',
                                                borderRadius: '5px',
                                                border: '1px solid #ccc',
                                                marginBottom: '10px',
                                                width: '90%',
                                            }}
                                        />

                                        <div>
                                            {filteredMachines.map((machine, index) => (
                                                <div key={index} style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    backgroundColor: '#e0e0e0',
                                                    alignItems: 'center',
                                                    padding: '5px',
                                                    borderRadius: '5px',
                                                    marginBottom: '8px',
                                                    fontSize: '12px',
                                                }}>
                                                    <div>
                                                        <span style={{ fontSize: '12px', display: 'block' }}>{machine.machine_name} - {machine.machine_id}</span>
                                                    </div>
                                                    <button
                                                        onClick={() => handleAddMachine(machine)}
                                                        disabled={addedMachines.some(m => m.id === machine.id)}
                                                        style={{
                                                            background: addedMachines.some(m => m.id === machine.id) ? 'gray' : 'green',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '5px',
                                                            padding: '5px',
                                                            cursor: addedMachines.some(m => m.id === machine.id) ? 'not-allowed' : 'pointer',
                                                            fontSize: '10px',
                                                        }}
                                                    >
                                                        {addedMachines.some(m => m.id === machine.id) ? 'Added' : 'Add'}
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: '48%' }}>
                                    <label style={{ marginBottom: '8px', display: 'block', fontWeight: 'bold' }}>
                                        Added Machines
                                    </label>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            padding: '10px',
                                            borderRadius: '5px',
                                            border: '1px solid #ccc',
                                            backgroundColor: '#f9f9f9',
                                            height: '150px',
                                            overflowY: 'auto',
                                        }}
                                    >
                                        {addedMachines.map((machine, index) => (
                                            <div key={index} style={{
                                                backgroundColor: '#e0e0e0',
                                                marginBottom: '5px',
                                                padding: '2px',
                                                borderRadius: '3px',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                fontSize: '12px'
                                            }}>
                                                <div>
                                                    <span style={{ fontSize: '12px', display: 'block' }}>{machine.machine_name} - {machine.machine_id}</span>
                                                </div>
                                                <button
                                                    onClick={() => handleRemoveMachine(machine.id)}
                                                    style={{
                                                        background: 'red',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '5px',
                                                        padding: '5px',
                                                        cursor: 'pointer',
                                                        fontSize: '10px',
                                                    }}
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginTop: '20px',
                                width: '50%',
                                marginLeft: '200px',
                            }}
                        >
                            <button
                                onClick={handleAddSchedule}
                                style={{
                                    backgroundColor: '#4CAF50',
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px 15px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    flex: '1',
                                    marginRight: '10px',
                                }}
                            >
                                Add Schedule
                            </button>
                            <button
                                onClick={() => setModalOpen(false)}
                                style={{
                                    backgroundColor: '#f44336',
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px 15px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    flex: '1',
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {isEditModalOpen && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div
                        ref={editMachineModalRef}
                        style={{
                            backgroundColor: 'white',
                            padding: '30px',
                            borderRadius: '8px',
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
                            width: '60%',
                            maxWidth: '600px',
                            height: '480px',
                            transition: 'all 0.3s ease',
                            overflowX: 'auto'
                        }}
                    >
                        <h4 style={{ marginBottom: '20px', textAlign: 'center' }}>Edit Schedule</h4>
                        <div style={{ display: 'flex', gap: '30px' }}>
                            <div style={{ flex: '1', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                <div style={{ display: 'flex', gap: '20px' }}>
                                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                                        <label>
                                            Schedule Name <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            value={editingSchedule.name}
                                            onChange={(e) => setEditingSchedule({ ...editingSchedule, name: e.target.value })}
                                            placeholder="Enter Schedule Name"
                                            style={{
                                                padding: '10px',
                                                border: '1px solid #ccc',
                                                borderRadius: '8px',
                                                width: '95%',
                                            }}
                                        />
                                    </div>
                                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                                        <label>
                                            Schedule Time <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <input
                                            type="time"
                                            value={editingSchedule.schedule_time || ''}
                                            onChange={(e) => setEditingSchedule({ ...editingSchedule, schedule_time: e.target.value })}
                                            step="60"
                                            style={inputStyle}
                                            pattern="[0-9]{2}:[0-9]{2}"
                                        />
                                    </div>
                                </div>

                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '20px',
                                }}>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center'
                                    }}>
                                        <label style={{ marginBottom: '5px' }}>
                                            Active State <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <input
                                                type="checkbox"
                                                id="edit-custom-checkbox"
                                                style={{ display: 'none' }}
                                                checked={editingSchedule.active}
                                                onChange={(e) => setEditingSchedule({
                                                    ...editingSchedule,
                                                    active: e.target.checked
                                                })}
                                            />
                                            <label
                                                htmlFor="edit-custom-checkbox"
                                                style={{
                                                    width: '40px',
                                                    height: '20px',
                                                    backgroundColor: editingSchedule.active ? '#4caf50' : '#ccc',
                                                    borderRadius: '50px',
                                                    position: 'relative',
                                                    cursor: 'pointer',
                                                    transition: 'background-color 0.3s',
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        position: 'absolute',
                                                        top: '3px',
                                                        left: editingSchedule.active ? '20px' : '3px',
                                                        width: '14px',
                                                        height: '14px',
                                                        backgroundColor: 'white',
                                                        borderRadius: '50%',
                                                        transition: '0.3s',
                                                    }}
                                                />
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', gap: '20px' }}>
                                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                                        <label>
                                            Report Type <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <select
                                            value={editingSchedule.report_type}
                                            onChange={(e) => setEditingSchedule({ ...editingSchedule, report_type: e.target.value })}
                                            style={{
                                                padding: '10px',
                                                border: '1px solid #ccc',
                                                borderRadius: '8px',
                                                width: '100%',
                                            }}
                                        >
                                            <option value="">Select Report Type</option>
                                            {reportTypeOptions.map((type) => (
                                                <option key={type} value={type}>
                                                    {type.charAt(0).toUpperCase() + type.slice(1)}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                                        <label>
                                            Report <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <select
                                            value={editingSchedule.report}
                                            onChange={(e) => setEditingSchedule({ ...editingSchedule, report: e.target.value })}
                                            disabled={!editingSchedule.report_type}
                                            style={{
                                                padding: '10px',
                                                border: '1px solid #ccc',
                                                borderRadius: '8px',
                                                width: '100%',
                                            }}
                                        >
                                            <option value="">Select Report</option>
                                            {editingSchedule.report_type &&
                                                reportOptions[editingSchedule.report_type].map((report) => (
                                                    <option key={report} value={report}>
                                                        {report}
                                                    </option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                                {(editingSchedule.report === 'meters') && (
                                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', marginBottom: '10px' }}>
                                        <div style={{ flex: '1' }}>
                                            <label htmlFor="meters" style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>Meters List</label>
                                            <div style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', height: '150px', overflowY: 'auto' }}>
                                                <input
                                                    type="text"
                                                    placeholder="Search meters..."
                                                    value={searchMeter}
                                                    onChange={handlemeterSearchChange}
                                                    style={{ padding: '5px', marginBottom: '10px', width: '90%', border: '1px solid #ccc', borderRadius: '4px' }}
                                                />
                                                {filteredMeter.map((meter, index) => (
                                                    <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px', backgroundColor: '#f9f9f9', padding: '5px', borderRadius: '4px' }}>
                                                        <div>
                                                            <span style={{ fontSize: '12px', display: 'block' }}>{meter.meter_name} - {meter.meter_id}</span>
                                                        </div>
                                                        <button
                                                            onClick={() => handleAddMeter(meter)}
                                                            disabled={addedMeters.some(m => m.meter_id === meter.meter_id)}
                                                            style={{
                                                                background: addedMeters.some(m => m.meter_id === meter.meter_id) ? 'gray' : 'green',
                                                                color: 'white',
                                                                border: 'none',
                                                                borderRadius: '5px',
                                                                padding: '5px',
                                                                cursor: addedMeters.some(m => m.meter_id === meter.meter_id) ? 'not-allowed' : 'pointer',
                                                                fontSize: '10px',
                                                            }}
                                                        >
                                                            {addedMeters.some(m => m.meter_id === meter.meter_id) ? 'Added' : 'Add'}
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div style={{ flex: '1' }}>
                                            <label style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>Added Meters</label>
                                            <div style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', height: '150px', overflowY: 'auto' }}>
                                                {addedMeters.map((meter, index) => (
                                                    <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px', backgroundColor: '#f9f9f9', padding: '5px', borderRadius: '4px' }}>
                                                        <div>
                                                            <span style={{ fontSize: '12px', display: 'block' }}>{meter.meter_name} - {meter.meter_id}</span>
                                                        </div>
                                                        <button
                                                            onClick={() => handleRemoveMeter(meter.meter_id)}
                                                            style={{
                                                                background: 'red',
                                                                color: 'white',
                                                                border: 'none',
                                                                borderRadius: '5px',
                                                                padding: '5px',
                                                                cursor: 'pointer',
                                                                fontSize: '10px',
                                                            }}
                                                        >
                                                            Remove
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', marginBottom: '10px' }}>
                            <div style={{ flex: '1' }}>
                                <label style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>
                                    User Select
                                </label>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        padding: '10px',
                                        borderRadius: '5px',
                                        border: '1px solid #ccc',
                                        backgroundColor: '#f9f9f9',
                                        height: '150px',
                                        overflowY: 'auto',
                                        position: 'relative',
                                    }}
                                >
                                    <input
                                        type="text"
                                        value={addsearchTerm}
                                        onChange={(e) => setAddSearchTerm(e.target.value)}
                                        placeholder="Search users..."
                                        style={{
                                            padding: '8px',
                                            borderRadius: '5px',
                                            border: '1px solid #ccc',
                                            marginBottom: '10px',
                                            width: '90%',
                                        }}
                                    />

                                    <div>
                                        {filteredUsers.map(([userId, username]) => {
                                            const isUserAdded = userList.includes(userId);
                                            return (
                                                <div
                                                    key={userId}
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        backgroundColor: '#e0e0e0',
                                                        alignItems: 'center',
                                                        padding: '5px',
                                                        borderRadius: '5px',
                                                        marginBottom: '8px',
                                                        fontSize: '12px',
                                                    }}
                                                >
                                                    <span style={{ color: isUserAdded ? 'gray' : 'black' }}>{username}</span>
                                                    <button
                                                        onClick={() => handleAddUser(userId)}
                                                        style={{
                                                            backgroundColor: isUserAdded ? 'gray' : '#4CAF50',
                                                            color: 'white',
                                                            border: 'none',
                                                            padding: '5px 10px',
                                                            borderRadius: '5px',
                                                            cursor: isUserAdded ? 'not-allowed' : 'pointer',
                                                            fontSize: '10px',
                                                            marginLeft: '10px',
                                                        }}
                                                        disabled={isUserAdded}
                                                    >
                                                        {isUserAdded ? 'Added' : 'Add'}
                                                    </button>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: '48%' }}>
                                <label style={{ marginBottom: '8px', display: 'block', fontWeight: 'bold' }}>
                                    Added Users
                                </label>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        padding: '10px',
                                        borderRadius: '5px',
                                        border: '1px solid #ccc',
                                        backgroundColor: '#f9f9f9',
                                        height: '150px',
                                        overflowY: 'auto',
                                    }}
                                >
                                    {userList.map(userId => (
                                        <div
                                            key={userId}
                                            style={{
                                                backgroundColor: '#e0e0e0',
                                                marginBottom: '5px',
                                                padding: '2px',
                                                borderRadius: '3px',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                fontSize: '12px'
                                            }}
                                        >
                                            <span>{usersData[userId]}</span>
                                            <button
                                                onClick={() => handleRemoveUser(userId)}
                                                style={{
                                                    backgroundColor: 'red',
                                                    color: 'white',
                                                    border: 'none',
                                                    padding: '5px',
                                                    borderRadius: '5px',
                                                    cursor: 'pointer',
                                                    fontSize: '10px'
                                                }}
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        {(editingSchedule.report === 'EMS Group') && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', marginBottom: '10px' }}>
                                <div style={{ flex: '1' }}>
                                    <label style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>
                                        EMS Groups List
                                    </label>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            padding: '10px',
                                            borderRadius: '5px',
                                            border: '1px solid #ccc',
                                            backgroundColor: '#f9f9f9',
                                            height: '150px',
                                            overflowY: 'auto',
                                            position: 'relative',
                                        }}
                                    >
                                        <input
                                            type="text"
                                            placeholder="Search EMS groups..."
                                            value={searchEmsGroup}
                                            onChange={handleEmsGroupSearchChange}
                                            style={{
                                                padding: '8px',
                                                borderRadius: '5px',
                                                border: '1px solid #ccc',
                                                marginBottom: '10px',
                                                width: '90%',
                                            }}
                                        />

                                        <div>
                                            {filteredEmsGroups.map((group, index) => (
                                                <div key={index} style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    backgroundColor: '#e0e0e0',
                                                    alignItems: 'center',
                                                    padding: '5px',
                                                    borderRadius: '5px',
                                                    marginBottom: '8px',
                                                    fontSize: '12px',
                                                }}>
                                                    <div>
                                                        <span style={{ fontSize: '12px', display: 'block' }}>{group.group_name}</span>
                                                    </div>
                                                    <button
                                                        onClick={() => handleAddEmsGroup(group)}
                                                        disabled={addedEmsGroups.some(g => g.group_name === group.group_name)}
                                                        style={{
                                                            background: addedEmsGroups.some(g => g.group_name === group.group_name) ? 'gray' : 'green',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '5px',
                                                            padding: '5px',
                                                            cursor: addedEmsGroups.some(g => g.group_name === group.group_name) ? 'not-allowed' : 'pointer',
                                                            fontSize: '10px',
                                                        }}
                                                    >
                                                        {addedEmsGroups.some(g => g.group_name === group.group_name) ? 'Added' : 'Add'}
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: '48%' }}>
                                    <label style={{ marginBottom: '8px', display: 'block', fontWeight: 'bold' }}>
                                        Added EMS Groups
                                    </label>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            padding: '10px',
                                            borderRadius: '5px',
                                            border: '1px solid #ccc',
                                            backgroundColor: '#f9f9f9',
                                            height: '150px',
                                            overflowY: 'auto',
                                        }}
                                    >
                                        {addedEmsGroups.map((group, index) => (
                                            <div key={index} style={{
                                                backgroundColor: '#e0e0e0',
                                                marginBottom: '5px',
                                                padding: '2px',
                                                borderRadius: '3px',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                fontSize: '12px'
                                            }}>
                                                <div>
                                                    <span style={{ fontSize: '12px', display: 'block' }}>{group.group_name}</span>
                                                </div>
                                                <button
                                                    onClick={() => handleRemoveEmsGroup(group.group_name)}
                                                    style={{
                                                        background: 'red',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '5px',
                                                        padding: '5px',
                                                        cursor: 'pointer',
                                                        fontSize: '10px',
                                                    }}
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                        {(editingSchedule.report === 'EnPI') && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', marginBottom: '10px' }}>
                                <div style={{ flex: '1' }}>
                                    <label style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>
                                        Machines List
                                    </label>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            padding: '10px',
                                            borderRadius: '5px',
                                            border: '1px solid #ccc',
                                            backgroundColor: '#f9f9f9',
                                            height: '150px',
                                            overflowY: 'auto',
                                            position: 'relative',
                                        }}
                                    >
                                        <input
                                            type="text"
                                            placeholder="Search machines..."
                                            value={searchMachine}
                                            onChange={handleMachineSearchChange}
                                            style={{
                                                padding: '8px',
                                                borderRadius: '5px',
                                                border: '1px solid #ccc',
                                                marginBottom: '10px',
                                                width: '90%',
                                            }}
                                        />

                                        <div>
                                            {filteredMachines.map((machine, index) => (
                                                <div key={index} style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    backgroundColor: '#e0e0e0',
                                                    alignItems: 'center',
                                                    padding: '5px',
                                                    borderRadius: '5px',
                                                    marginBottom: '8px',
                                                    fontSize: '12px',
                                                }}>
                                                    <div>
                                                        <span style={{ fontSize: '12px', display: 'block' }}>{machine.machine_name} - {machine.machine_id}</span>
                                                    </div>
                                                    <button
                                                        onClick={() => handleAddMachine(machine)}
                                                        disabled={addedMachines.some(m => m.id === machine.id)}
                                                        style={{
                                                            background: addedMachines.some(m => m.id === machine.id) ? 'gray' : 'green',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '5px',
                                                            padding: '5px',
                                                            cursor: addedMachines.some(m => m.id === machine.id) ? 'not-allowed' : 'pointer',
                                                            fontSize: '10px',
                                                        }}
                                                    >
                                                        {addedMachines.some(m => m.id === machine.id) ? 'Added' : 'Add'}
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: '48%' }}>
                                    <label style={{ marginBottom: '8px', display: 'block', fontWeight: 'bold' }}>
                                        Added Machines
                                    </label>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            padding: '10px',
                                            borderRadius: '5px',
                                            border: '1px solid #ccc',
                                            backgroundColor: '#f9f9f9',
                                            height: '150px',
                                            overflowY: 'auto',
                                        }}
                                    >
                                        {addedMachines.map((machine, index) => (
                                            <div key={index} style={{
                                                backgroundColor: '#e0e0e0',
                                                marginBottom: '5px',
                                                padding: '2px',
                                                borderRadius: '3px',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                fontSize: '12px'
                                            }}>
                                                <div>
                                                    <span style={{ fontSize: '12px', display: 'block' }}>{machine.machine_name} - {machine.machine_id}</span>
                                                </div>
                                                <button
                                                    onClick={() => handleRemoveMachine(machine.id)}
                                                    style={{
                                                        background: 'red',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '5px',
                                                        padding: '5px',
                                                        cursor: 'pointer',
                                                        fontSize: '10px',
                                                    }}
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginTop: '20px',
                                width: '50%',
                                marginLeft: '200px',
                            }}
                        >
                            <button
                                onClick={handleUpdateSchedule}
                                style={{
                                    backgroundColor: '#4CAF50',
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px 15px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    flex: '1',
                                    marginRight: '10px',
                                }}
                            >
                                Update Schedule
                            </button>
                            <button
                                onClick={() => setEditModalOpen(false)}
                                style={{
                                    backgroundColor: '#f44336',
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px 15px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    flex: '1',
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {isDeleteModalOpen && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            backgroundColor: 'white',
                            padding: '30px',
                            borderRadius: '8px',
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
                            width: '400px',
                            maxWidth: '90%',
                            textAlign: 'center',
                        }}
                    >
                        <h3 style={{ marginBottom: '20px' }}>Confirm Deletion</h3>
                        <p>Are you sure you want to delete the selected schedules?</p>

                        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '30px' }}>
                            <button
                                onClick={handleDeleteSchedules}
                                style={{
                                    backgroundColor: '#f44336',
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px 20px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    minWidth: '100px',
                                }}
                            >
                                Yes, Delete
                            </button>
                            <button
                                onClick={() => setDeleteModalOpen(false)}
                                style={{
                                    backgroundColor: '#cccccc',
                                    color: '#333333',
                                    border: 'none',
                                    padding: '10px 20px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    minWidth: '100px',
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ScheduleDetails;